import React, { Fragment } from 'react';
import TableHeader from './TableHeader';
import ScopeRow from './ScopeRow';
import MonthHeader from './MonthHeader';
import BudgetWarningsSummary from './BudgetWarningsSummary';
import TotalsRow from './TotalsRow';
import EmptyRow from './EmptyRow';

const BudgetItemsTable = ({ 
  sortConfig, 
  requestSort,
  groupedScopes,
  sortedScopes,
  hasActiveFilters,
  onSelectScope
}) => {
  return (
    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 dark:ring-white dark:ring-opacity-5 sm:rounded-lg">
      <table className="min-w-full divide-y divide-gray-300 dark:divide-gray-700">
        <TableHeader sortConfig={sortConfig} requestSort={requestSort} />
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
          {sortedScopes.length === 0 ? (
            <EmptyRow hasActiveFilters={hasActiveFilters} />
          ) : (
            groupedScopes.map((group, groupIndex) => (
              <Fragment key={groupIndex}>
                {/* Month header row */}
                <MonthHeader month={group.month} />
                
                {/* Scopes within this month group */}
                {group.scopes.map((scope, index) => (
                  <ScopeRow 
                    key={`${groupIndex}-${index}`}
                    scope={scope} 
                    groupIndex={groupIndex} 
                    index={index}
                    onSelectScope={onSelectScope}
                  />
                ))}
              </Fragment>
            ))
          )}
          
          {/* Budget warnings summary and Totals rows - only show if we have data */}
          {sortedScopes.length > 0 && (
            <>
              <BudgetWarningsSummary sortedScopes={sortedScopes} />
              <TotalsRow sortedScopes={sortedScopes} />
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BudgetItemsTable;